<template>
    <div class="vx-row mb-2">
        <div class="core vx-col w-full mb-base">
            <div v-for="(item, index) in data.records.all_visits" :key="index" class="my-2">
                <span class="text-lg text-bold">{{ item.schedule_date }}</span>
                <vs-table stripe border :data="processedData" :sst="false" :max-items="processedData.length" class="mt-2">
                    <template slot="thead">
                        <vs-th>Detail</vs-th>
                        <vs-th>Visit Date</vs-th>
                        <vs-th>Latitude Visit</vs-th>
                        <vs-th>Longitude Visit</vs-th>
                        <vs-th>Customer</vs-th>
                        <vs-th>Latitude Customer</vs-th>
                        <vs-th>Longitude Customer</vs-th>
                        <vs-th>Distance</vs-th>
                        <vs-th>Route Status</vs-th>
                        <vs-th>Start Time</vs-th>
                        <vs-th>End Time</vs-th>
                        <vs-th>Duration (minute)</vs-th>
                        <vs-th>Visited</vs-th>
                        <vs-th>Effective Call</vs-th>
                        <vs-th>Document Reference</vs-th>
                        <vs-th>Reason Out of Radius</vs-th>
                        <vs-th>Reason Non Visit</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td class="whitespace-no-wrap">
                                <div class="flex flex-row space-x-1">
                                    <vx-tooltip text="Detail">
                                        <vs-button
                                            type="line"
                                            icon-pack="feather"
                                            @click="openDetailV2(tr)"
                                            icon="icon-eye"
                                            :disabled="!tr.attachment"
                                        />
                                    </vx-tooltip>
                                </div>
                            </vs-td>
                            <vs-td>{{ tr.visit_date }}</vs-td>
                            <vs-td>{{ tr.latitudeVisit }}</vs-td>
                            <vs-td>{{ tr.longitudeVisit }}</vs-td>
                            <vs-td>{{ tr.customer_code + " - " + tr.customer_name }}</vs-td>
                            <vs-td>{{ tr.latitudeCustomer }}</vs-td>
                            <vs-td>{{ tr.longitudeCustomer }}</vs-td>
                            <vs-td>
                              {{
                                distanceBetweenCustomerAndVisit(
                                    tr.latitudeVisit,
                                    tr.longitudeVisit,
                                    tr.latitudeCustomer,
                                    tr.longitudeCustomer
                                )
                              }}
                            </vs-td>
                            <vs-td>{{ tr.route_status }}</vs-td>
                            <vs-td>{{ tr.start_time }}</vs-td>
                            <vs-td>{{ tr.end_time }}</vs-td>
                            <vs-td>{{ tr.start_end_duration }}</vs-td>
                            <vs-td>{{ tr.is_visited }}</vs-td>
                            <vs-td>{{ tr.effective_call }}</vs-td>
                            <vs-td>{{ tr.ex_code }}</vs-td>
                            <vs-td>{{ tr.reason }}</vs-td>
                            <vs-td>{{ tr.reason_non_visit != '' ? tr.reason_non_visit : tr.reason_non_order }}</vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
        </div>

<!--        <ModalAttachment :active="activeProP" :fileAttachment="fileAttachment" @close="activeProP = false"></ModalAttachment>-->
        <ModalMap :active="activeProP" :fileAttachment="fileAttachment" :mapData="mapData" @close="activeProP = false" />
    </div>
</template>

<script>
import ModalAttachment from './modalAttachment.vue'
import ModalMap from './modalMap.vue'

export default {
    components: {
        ModalAttachment,
        ModalMap
    },
    name: "DataTable",
    props: {
        data: {
            type: Array,
            default: () => [],
            required: true,
        },
    },
    data() {
        return {
            activeProP: false,

            // attachments section
            file: null,
            fileUrl: '',
            attachment: "",
            fileAttachment: [],
            IDAttachment: [],
            visible: false,
            images: [],
            index: 0,
            mapData: {
              latitude: null,
              longitude: null,
              customerLocation: null,
              salesInformation: null,
              customerInformation: null,
            }
        }
    },
    methods: {
        openDetail(val) {
            this.fileAttachment = []
            this.images = []

            if (val.attachment) {
                val.attachment.forEach((v) => {
                    this.fileAttachment.push({
                        id: v.id,
                        NameFile: v.file_name,
                        PathFile: v.file_url,
                    })
                    this.images.push(v.file_url)
                })

                this.activeProP = true
            }
        },
      openDetailV2(val) {
        const latLongSales = val.lat_long_visit.split(" ")
        const latLongCustomer = val.lat_long_master_customer.split(" ")

        const [latSales, longSales] = latLongSales
        const [latCustomer, longCustomer] = latLongCustomer

        this.mapData = {
          latitude: latSales,
          longitude: longSales,
          customerLocation: {
            latitude: latCustomer,
            longitude: longCustomer
          },
          salesInformation: {
            name: val.sales_name,
            code: val.sales_code,
            latitude: Number(latSales),
            longitude: Number(longSales),
          },
          customerInformation:{
            name: val.customer_name,
            code: val.customer_code,
            address: val.customer_address,
            latitude: Number(latCustomer),
            longitude: Number(longCustomer),
          },
          timeStamp: `${val.schedule_date} ${val.end_time}`,
          isOutOfRange: val.is_out_of_distance
        }

        console.log(this.mapData)

        this.fileAttachment = []
        this.images = []

        if (val.attachment) {
          val.attachment.forEach((v) => {
            this.fileAttachment.push({
              id: v.id,
              NameFile: v.file_name,
              PathFile: v.file_url,
            })
            this.images.push(v.file_url)
          })
        }

        this.activeProP = true
      },
        distanceBetweenCustomerAndVisit(
            latitudeVisit,
            longitudeVisit,
            latitudeCustomer,
            longitudeCustomer
        ) {
          if (
              !latitudeVisit ||
              !longitudeVisit ||
              !latitudeCustomer ||
              !longitudeCustomer
          ) {
            return "-";
          }

          const R = 6371;

          const dLat = this.deg2rad(latitudeVisit - latitudeCustomer);
          const dLon = this.deg2rad(longitudeVisit - longitudeCustomer);

          const a =
              Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(this.deg2rad(latitudeCustomer)) *
              Math.cos(this.deg2rad(latitudeVisit)) *
              Math.sin(dLon / 2) *
              Math.sin(dLon / 2);

          const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
          const distance = R * c;

          return distance < 1
              ? `${(distance * 1000).toFixed(2)} m`
              : `${distance.toFixed(2)} km`;
        },
        deg2rad(deg) {
          return deg * (Math.PI / 180);
        },
    },
    computed: {
        urlFile: () => {
            return (tr) => {
                return tr.File instanceof Blob ? URL.createObjectURL(tr.File) : tr.PathFile
            }
        },
      processedData() {
        return this.data.records.all_visits[0].visits.map(item => {
          console.log(item)
          // Cek apakah data koordinat ada

          const [latVisit, longVisit] = item.lat_long_visit.split(' ');
          const [latCustomer, longCustomer] = item.lat_long_master_customer.split(' ');

          return {
            ...item,
            latitudeVisit: latVisit,
            longitudeVisit: longVisit,
            latitudeCustomer: latCustomer,
            longitudeCustomer: longCustomer,
          };
        });
      },
    },
};
</script>